module.exports = __webpack_public_path__ + "static/media/kiosk-self-order.c74b810a.svg";